import React from "react";
import { withScriptjs } from "react-google-maps";
import PickImg from "images/pick-icon.svg";
import DropImg from "images/drop-icon.svg";
import DateImg from "images/calendar.svg";
import TimeImg from "images/clock.svg";
import DistanceImg from "images/distance.svg";
import StopTimeImg from "images/chronograph-watch.svg";
import FleetImg from "images/minivan-car.svg";
import CashImg from "images/cash-bag.svg";
import fleetSUV from "images/suv.png";
import fleetVan from "images/van.png";
import PaxIcon from "images/user.png";
import LugIcon from "images/suitcase.png";
import Map from "./map.js";
const MapLoader = withScriptjs(Map);

export default class QuoteInfo extends React.Component {
  counter = 0;
  quote = {};
  quoteFleet = {};
  quoteFleetSelected = false;

  constructor(props) {
    super(props);
    this.quote = props.quoteData;
    if (props.fleetData !== undefined) {
      this.quoteFleet = props.fleetData;
      this.quoteFleetSelected = true;
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return false;
  }

  render() {
    return (
      <div>
        <div className="route-map mb-3">
          <MapLoader
            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDyTJUE1-ZOt3WmqonHbK1U9vFGpablM88"
            loadingElement={<div style={{ height: `100%` }} />}
            quoteData={this.quote}
          />
        </div>

        <div className="media">
          <img className="mr-3" alt="" src={PickImg} />
          <div className="media-body">
            <h5 className="mt-0">Pickup Address</h5>
            <span>{this.quote.start}</span>
          </div>
        </div>
        <div className="splitter"></div>
        <div className="media">
          <img className="mr-3" alt="" src={DropImg} />
          <div className="media-body">
            <h5 className="mt-0">Drop off Address</h5>
            <span>{this.quote.end}</span>
          </div>
        </div>
        <div className="splitter"></div>
        <div className="media">
          <img className="mr-3" alt="" src={DateImg} />
          <div className="media-body">
            <h5 className="mt-0">Pickup Date</h5>
            <span> {this.quote.pickup_date}</span>
          </div>
        </div>
        <div className="splitter"></div>
        <div className="media">
          <img className="mr-3" alt="" src={TimeImg} />
          <div className="media-body">
            <h5 className="mt-0">Pickup Time</h5>
            <span> {this.quote.pickup_time}</span>
          </div>
        </div>
        <div className="splitter"></div>
        <div className="media">
          <img className="mr-3" alt="" src={DistanceImg} />
          <div className="media-body">
            <h5 className="mt-0">Distance</h5>
            <span>
              {(this.quote.one_way_distance / 1000).toFixed(2)} km /{" "}
              {(this.quote.one_way_distance * 0.000621371).toFixed(2)} Miles{" "}
            </span>
          </div>
        </div>
        <div className="splitter"></div>
        <div className="media">
          <img className="mr-3" alt="" src={StopTimeImg} />
          <div className="media-body">
            <h5 className="mt-0">Duration</h5>
            <span> {Math.floor(this.quote.one_way_duration / 60)} mins</span>
          </div>
        </div>
        <div className="splitter"></div>
        <div className="media">
          <img className="mr-3" alt="" src={PaxIcon} />
          <div className="media-body">
            <h5 className="mt-0">Passenger</h5>
            <span> {this.quote.no_of_passengers} </span>
          </div>
          <img className="mr-3" alt="" src={LugIcon} />
          <div className="media-body">
            <h5 className="mt-0">Luggage</h5>
            <span> {this.quote.no_of_luggage} </span>
          </div>
        </div>

        {this.quoteFleetSelected && (
          <div>
            <div className="splitter"></div>
            <div className="media">
              <img className="mr-3" alt="" src={FleetImg} />
              <div className="media-body">
                <h5 className="mt-0">Vehicle</h5>
                <span> {this.quoteFleet.type_class.name}</span>

                {this.quoteFleet.type_class.name === "Passenger Van" ? (
                  <img
                    style={{
                      display: "inline-block",
                      float: "right",
                      width: "150px",
                      marginTop: "-40px",
                    }}
                    src={fleetVan}
                  />
                ) : (
                  <img
                    style={{
                      display: "inline-block",
                      float: "right",
                      width: "150px",
                      marginTop: "-40px",
                    }}
                    src={fleetSUV}
                  />
                )}
              </div>
            </div>
            <div className="splitter"></div>
            <div className="media">
              <img className="mr-3" alt="" src={CashImg} />
              <table
                cellPadding="0"
                style={{ width: "100%" }}
                cellSpacing="0"
                role="presentation"
              >
                <thead>
                  <tr>
                    <th align="left">
                      <h6 className="mb-2 mt-3">Description</h6>
                    </th>
                    <th align="right">
                      <h6 className="mb-2 mt-3" style={{ textAlign: "right" }}>
                        Amount
                      </h6>
                    </th>
                  </tr>
                </thead>
                <tbody>
                {this.quote.trip_type === "round_trip" && (
                    <tr >
                        <td colSpan={2} style={{
                            textAlign: "center",
                            borderBottom: "1px solid #c29d07",
                        }}>One Way</td>
                    </tr>
                )}


                  <tr>
                    <td>Base Fare</td>
                    <td align="right">${this.quoteFleet.fare_data.fare}</td>
                  </tr>
                  {this.quoteFleet.fare_data.additional.charges.map(
                    (charge, i) =>
                      charge.value > 0 && (
                        <tr key={i}>
                          <td>{charge.name}</td>
                          <td align="right">${charge.value}</td>
                        </tr>
                      )
                  )}
                {this.quote.trip_type === "round_trip" && (
                    <tr>
                        <td colSpan={2}  style={{
                            textAlign: "center",
                            borderBottom: "1px solid #c29d07",
                        }}>Return Journey</td>
                    </tr>
                )}
                {this.quote.trip_type === "round_trip" && (
                    <tr>
                        <td>Base Fare</td>
                        <td align="right">${this.quoteFleet.fare_data.return_fare}</td>
                    </tr>
                )}
                {this.quote.trip_type === "round_trip" && this.quoteFleet.fare_data.return_additional.charges.map(
                            (charge, i) =>
                                charge.value > 0 && (
                                    <tr key={i}>
                                        <td>{charge.name}</td>
                                        <td align="right">${charge.value}</td>
                                    </tr>
                                )
                        )}
                  <tr>
                    <td>
                      <h5 style={{ marginBottom: "15px" }}>
                        {this.quoteFleet.fleet_count ? "Sub Total" : "Total"}
                      </h5>
                    </td>
                    <td>
                      <h4 align="right">${(this.quote.trip_type === "round_trip" ? (this.quoteFleet.fare_data.one_way_total + this.quoteFleet.fare_data.return_total) : this.quoteFleet.fare_data.one_way_total).toFixed(2)}</h4>
                    </td>
                  </tr>
                  {this.quoteFleet.fleet_count && (
                    <tr
                      style={{
                        borderTop: "1px solid #ddd",
                        height: "75px",
                        color: "#243E63",
                        fontSize: "18px",
                      }}
                    >
                      <td>
                        <h3 className="text-left">
                          Total <br /> ({this.quoteFleet.fleet_count} fleet X $
                          {(this.quote.trip_type === "round_trip" ? (this.quoteFleet.fare_data.one_way_total + this.quoteFleet.fare_data.return_total) : this.quoteFleet.fare_data.one_way_total).toFixed(2)})
                        </h3>
                      </td>
                      <td>
                        <h4
                          style={{
                            textAlign: "right",
                            fontSize: "30px",
                            color: "#C29D07",
                            position: "relative",
                            top: "0px",
                          }}
                        >
                          $
                          {(this.quote.trip_type === "round_trip" ? (this.quoteFleet.fare_data.one_way_total + this.quoteFleet.fare_data.return_total) : this.quoteFleet.fare_data.one_way_total *
                            this.quoteFleet.fleet_count).toFixed(2)}
                        </h4>
                      </td>
                    </tr>
                  )}

                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  }
}
